
<div
  v-if="!isClosed"
  ref="banner"
  class="ws-state-banner column"
  :class="`${size} ${type}`"
>
  <div class="ws-state-banner__inner-wrapper flex row">
    <ws-icon
      v-if="icon"
      :name="getIcon()"
      :size="24"
    />

    <div
      v-if="!$slots.default"
      class="ws-state-banner__content"
    >
      <div class="ws-state-banner__title">
        <slot name="title">
          {{ title }}
        </slot>
      </div>

      <p
        class="ws-state-banner__text"
        :class="{'ws-state-banner__text--no-title':!title && !$slots.title}"
      >
        <slot name="text">
          <ws-html :value="text" />
        </slot>
      </p>
    </div>

    <slot></slot>

    <div
      v-if="closable"
      class="ws-state-banner__closable flex justify-end"
    >
      <ws-button
        :type="WsButtonEnum.Type.GHOST"
        :size="WsButtonEnum.Size.SMALL"
        icon="close"
        @click="closeBanner"
      />
    </div>
  </div>
  <div
    v-if="button"
    class="flex justify-end"
  >
    <ws-button
      class="self-end ws-state-banner__button"
      padding="4px 8px"
      :element="WsButtonEnum.Element.A"
      :type="buttonType"
      :icon="buttonIcon"
      :href="buttonUrl"
    >
      {{ buttonLabel }}
    </ws-button>
  </div>
  <div
    v-if="$slots.buttonSlot"
    class="flex justify-end"
  >
    <slot name="buttonSlot"></slot>
  </div>
</div>
